// @ts-nocheck
import React, { Component } from "react";
import delegateImg from "../../../../../../assets/image/delegate.png";
import "../index.scss";

export default class DelegationIcon extends Component {
  constructor(props: any) {
    super(props);
    this.state = {
      editIcon: delegateImg,
      isModalOpen: false,
      isEditTipOpen: false,
    };
  }

  /**
   * function about change icon to hover icon when hovering edit icon
   */
  handleEditIconHover = () => {
    this.setState({ editIcon: delegateImg });
  };

  /**
   * function about change icon to default icon when leaving edit icon
   */
  handleEditIconDefault = () => {
    this.setState({ editIcon: delegateImg });
  };

  /**
   * function about click edit icon
   */
  handleEditClick = () => {
    // @ts-ignore
    this.props.handleModalOpen();
  };

  render() {
    // @ts-ignore
    const { editIcon } = this.state;
    // @ts-ignore
    const { disabled } = this.props;
    return (
      // @ts-ignore
      <div
        onMouseEnter={!disabled && this.handleEditIconHover}
        onMouseLeave={!disabled && this.handleEditIconDefault}
        onBlur={() => this.setState({ isEditTipOpen: false })}
        onClick={this.handleEditClick}
        className={`editIcon ${disabled && "editDisabled"}`}
        data-testid="delegation-icon-btn"
      >
        <img src={editIcon} alt="edit icon" />
      </div>
    );
  }
}
